<template>
  <div>
    <h1>Welcome to vue-aui!
      <a href="https://badge.fury.io/js/vue-aui"><img src="https://badge.fury.io/js/vue-aui.svg"/></a>
    </h1>
    <p>
      vue-aui is <a href="https://github.com/vuejs/vue">Vuejs</a> 2 wrapper over <a href="https://docs.atlassian.com/aui/">Atlassian User Interface</a>.
    </p>
    <h2>Installation</h2>
    <p><a href="https://github.com/spartez/vue-aui#installation">Link</a></p>
    <h2>Demo</h2>
    <p>

      <iframe height='400' scrolling='no' title='vue-aui demo'
              src='//codepen.io/damienix/embed/woXRpP/?height=305&theme-id=light&default-tab=html,result&embed-version=2'
              frameborder='no' allowtransparency='true' allowfullscreen='true' style='width: 100%;'>See the Pen <a
        href='http://codepen.io/damienix/pen/woXRpP/'>vue-aui demo</a> by Damian Skrodzki (<a
        href='http://codepen.io/damienix'>@damienix</a>) on <a href='http://codepen.io'>CodePen</a>.
      </iframe>
    </p>
  </div>
</template>

<script>
  export default {}
</script>
